import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "./Testimonials.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import API_BASE_URL from "../config/api";

function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTestimonials = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/testimonials`);
      if (!response.ok) {
        throw new Error("Failed to fetch testimonials");
      }
      const data = await response.json();
      setTestimonials(data);
    } catch (error) {
      setError("Failed to fetch testimonials. Please try again later.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  // Updated slider settings: Always display one card
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1, // Only one card at a time
    slidesToScroll: 1,
    arrows: false,
    centerMode: false, // Disable centering to prevent partial slides on the sides
  };

  if (loading) {
    return <div className="testimonial-container">Loading testimonials...</div>;
  }

  if (error) {
    return <div className="testimonial-container">{error}</div>;
  }

  return (
    <div className="testimonial-container">
      <div className="testimonial-header">
        <p className="testimonial-title1">Testimonial</p>
        <h2 className="testimonial-subtitle">What Client Say About US</h2>
      </div>
      <Slider {...settings} className="testimonial-carousel">
        {testimonials.map((testimonial) => (
          <div className="testimonial-card" key={testimonial._id}>
            <div className="testimonial-content">
              <div className="testimonial-info">
                <div className="testimonial-avatar">
                  <img
                    src={testimonial.avatarUrl}
                    alt={`${testimonial.name}'s avatar`}
                    className="avatar-image"
                  />
                </div>
                <div>
                  <p className="testimonial-name">{testimonial.name}</p>
                  <p className="testimonial-title">{testimonial.title}</p>
                </div>
              </div>
              <ReviewText review={testimonial.review} />
              <div className="testimonial-rating">
                {"★".repeat(testimonial.rating)}
                {"☆".repeat(5 - testimonial.rating)}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

function ReviewText({ review }) {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  const getShortText = (text) => {
    const words = text.split(" ");
    return words.length > 20 ? words.slice(0, 20).join(" ") + "..." : text;
  };

  return (
    <p className="testimonial-review">
      {expanded ? review : getShortText(review)}{" "}
      {review.split(" ").length > 20 && (
        <button onClick={toggleExpanded} className="read-more-btn">
          {expanded ? "Show Less" : "Read More"}
        </button>
      )}
    </p>
  );
}

export default Testimonials;
